import { Box, Flex, Image, Text } from "@chakra-ui/react";
import React from "react";
import { PatientImg, VideoCallIcon, VoiceCallIcon } from "../../../assets";
import { useParams } from "react-router-dom";
import colors from "../../../utils/colors";
import { renderAppointmentTypeCell } from "./PatientsTable";

const PatientCard = ({ patient }) => {
  return (
    <Flex
      boxShadow={"1px 4px 15px 0px #3030301F"}
      backgroundColor={"white"}
      //   width={"180px"}
      //   height={"293px"}
      borderRadius={"8px"}
      padding={"20px"}
      gap={"20px"}
      alignItems={"center"}
      direction={"column"}
    >
      <Image src={PatientImg} borderRadius={"50px"} boxSize={"80px"} />
      <Flex direction={"column"} gap={"5px"}>
        <Text
          fontFamily={"lato"}
          fontWeight={400}
          fontSize={"18px"}
          lineHeight={"21.6px"}
          color={"black"}
          textAlign={"center"}
        >
          {patient?.name}
        </Text>
        <Text
          fontFamily={"lato"}
          fontWeight={400}
          fontSize={"16px"}
          lineHeight={"19px"}
          color={colors.placeholderColor}
          textAlign={"center"}
        >
          ID: {patient?.id}
        </Text>
      </Flex>
      <Flex gap={"20px"}>
        <Image src={VoiceCallIcon} />
        <Image src={VideoCallIcon} />
      </Flex>
      {renderAppointmentTypeCell(patient?.risk)}
    </Flex>
  );
};

export default PatientCard;
